import { DocumentReference } from '@marmon/shared/types/common';
import { User } from '../interfaces';

export class UserItem {
	name!: string;
	email!: string;
	id!: string;
	ref!: DocumentReference<User>;

	constructor(user: User, ref: DocumentReference<User>) {
		this.name = user.displayName;
		this.email = user.email;
		this.id = user.id;
		this.ref = ref;
	}

	toString(): string {
		return this.email ? `${this.name} (${this.email})` : this.name;
	}

	valueOf(): DocumentReference<User> {
		return this.ref;
	}
}
